import {gql} from "@apollo/client";

import {OpenGraph} from "./opengraph";
import {PostService} from "./collection";

export interface SocialShuffleChat {
	message: string;
	prompt: string;
	id: string;
	service: PostService;
}
export interface ShuffledComment {
	isAIGenerated: boolean;
	openGraph: OpenGraph;
}
export interface ShuffledImage {
	id: string;
	image: string;
}

const AI_CHAT_FRAGMENT = gql`
	fragment AIChatFields on SocialShuffleChat {
		message
		prompt
		id
		service
	}
`;

export const REFRESH_SHUFFLE_AI = gql`
	mutation SocialShuffleChat($aiChat: SocialShuffleChatInput!) {
		refreshSocialShuffle(aiChat: $aiChat) {
			...AIChatFields
		}
	}
	${AI_CHAT_FRAGMENT}
`;
